import {IReduxWebSocketServiceState} from '../../../@interfaces';

const state: IReduxWebSocketServiceState = {
    connectionState: 'connecting',
    channels: {},
};

export default state;
